var tag = document.createElement('script')
  tag.src = "https://www.youtube.com/iframe_api"

var firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

var playerVideo = $("#playerHero")

if(playerVideo.length){

  // Create the video
  var player

  function onYouTubeIframeAPIReady() {
    player = new YT.Player('playerHero', {
      height: '940',
      width: '1440',
      loop: 1,
      videoId: 'tEU9wlwyZ2Q',
      events: {
        'onStateChange': onPlayerStateChange,
        'onReady': videoReady
      }
    })
  }

  // Play the vídeo
  var btnPlayVideo = $(".playVideo"),
    videowrapper = $(".hero__videoWrapper")
  btnPlayVideo.on("click", function(){
    player.playVideo()
    player.mute()
    videowrapper.addClass("active")
  })

  // Close the vídeo
  var btnCloseVideo = $(".closeVideo")
  btnCloseVideo.on("click", function(){
    player.pauseVideo()
    videowrapper.removeClass("active")
  })

  // Event: ended video
  function onPlayerStateChange(event){
    if ( event.data == YT.PlayerState.ENDED){
      videowrapper.removeClass("active")
    }
  }

  // Event: onReady
  function videoReady(){  

    if(!detectTouchDevice()){
      player.playVideo()
      player.mute()
      videowrapper.addClass("active")
    }
    
  }

  // Detect Touch Device
  function detectTouchDevice() {
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
  }

}